var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopularLinks(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.91,
    height: 41.905,
    viewBox: "0 0 41.91 41.905",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12964",
    "data-name": "Group 12964",
    transform: "translate(-5.045 -5.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21074",
    "data-name": "Path 21074",
    d: "M15.75,46.96a9.962,9.962,0,0,1-7.07-2.92l-.71-.71a10.007,10.007,0,0,1,0-14.14L17.16,20a9.011,9.011,0,0,1,12.73,0l2.12,2.12a1,1,0,1,1-1.41,1.41l-2.12-2.12a7.007,7.007,0,0,0-9.9,0L9.39,30.6a8,8,0,0,0,0,11.31l.71.71a8,8,0,0,0,11.31,0l5.66-5.66a1,1,0,0,1,1.41,1.41l-5.66,5.66a9.962,9.962,0,0,1-7.07,2.92Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21075",
    "data-name": "Path 21075",
    d: "M15.75,42.75a6.5,6.5,0,0,1-4.6-11.09l8.13-8.13a6.011,6.011,0,0,1,8.49,0l.71.71a1,1,0,0,1-1.41,1.41l-.71-.71a4.008,4.008,0,0,0-5.66,0l-8.13,8.13a4.5,4.5,0,1,0,6.36,6.36l3.89-3.89a1,1,0,0,1,1.41,1.41l-3.89,3.89a6.451,6.451,0,0,1-4.6,1.9Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21076",
    "data-name": "Path 21076",
    d: "M28.47,34.65a8.942,8.942,0,0,1-6.36-2.64l-2.12-2.12a1,1,0,0,1,1.41-1.41l2.12,2.12a7,7,0,0,0,9.9,0l9.19-9.19a8,8,0,0,0,0-11.31l-.71-.71a8,8,0,0,0-11.31,0l-5.66,5.66a1,1,0,0,1-1.41-1.41l5.66-5.66a10.007,10.007,0,0,1,14.14,0l.71.71a10.007,10.007,0,0,1,0,14.14l-9.19,9.19a8.942,8.942,0,0,1-6.36,2.64Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21077",
    "data-name": "Path 21077",
    d: "M28.47,30.23a5.964,5.964,0,0,1-4.24-1.75l-.71-.71a1,1,0,0,1,1.41-1.41l.71.71a4.008,4.008,0,0,0,5.66,0l8.13-8.13a4.5,4.5,0,1,0-6.36-6.36l-3.89,3.89a1,1,0,0,1-1.41-1.41l3.89-3.89a6.5,6.5,0,1,1,9.19,9.19l-8.13,8.13a5.981,5.981,0,0,1-4.24,1.75Z",
    fill: "#010101"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopularLinks);
export default __webpack_public_path__ + "static/media/popular_links.eaf9ab6608b0bf2fee4bd0bffdcd9279.svg";
export { ForwardRef as ReactComponent };